import { render, staticRenderFns } from "./row-card.vue?vue&type=template&id=0d63b242"
import script from "./row-card.vue?vue&type=script&lang=js"
export * from "./row-card.vue?vue&type=script&lang=js"
import style0 from "./row-card.vue?vue&type=style&index=0&id=0d63b242&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d63b242')) {
      api.createRecord('0d63b242', component.options)
    } else {
      api.reload('0d63b242', component.options)
    }
    module.hot.accept("./row-card.vue?vue&type=template&id=0d63b242", function () {
      api.rerender('0d63b242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/row-card.vue"
export default component.exports